import { orange } from '@/theme/colors'
import styled from 'styled-components'

export const ViewerGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
	gap: 0.75rem;
`

export const ViewerFileCard = styled.div`
	background: white;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
	cursor: pointer;
	transition: all 0.2s ease;
	border: 1px solid #e5e7eb;

	&:hover {
		box-shadow: 0 3px 10px rgba(0, 0, 0, 0.12);
		transform: translateY(-1px);
	}
`

export const ViewerThumbnail = styled.div`
	width: 100%;
	aspect-ratio: 1;
	overflow: hidden;
	background: #f3f4f6;
	display: flex;
	align-items: center;
	justify-content: center;

	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}
`

export const ViewerDocIcon = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
	color: #9ca3af;

	span {
		font-size: 0.65rem;
		font-weight: 600;
		text-transform: uppercase;
		color: #6b7280;
	}
`

export const ViewerFileName = styled.div`
	padding: 0.375rem 0.5rem;
	font-size: 0.7rem;
	color: #374151;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`

export const EmptyViewerState = styled.div`
	text-align: center;
	padding: 2rem 1rem;
	color: #9ca3af;
	font-size: 0.875rem;
`

export const EditButton = styled.button`
	background: none;
	border: 1px solid ${orange};
	color: ${orange};
	padding: 0.375rem 0.75rem;
	border-radius: 6px;
	font-size: 0.75rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.15s;

	&:hover {
		background: ${orange};
		color: white;
	}
`

export const ViewerFooter = styled.div`
	display: flex;
	justify-content: flex-end;
	padding-top: 0.5rem;
`

// Image lightbox
export const LightboxBackdrop = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.9);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1100;
	padding: 2rem;
`

export const LightboxContainer = styled.div`
	position: relative;
	max-width: 90vw;
	max-height: 90vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1rem;

	img {
		max-width: 90vw;
		max-height: 80vh;
		object-fit: contain;
		border-radius: 8px;
	}
`

export const LightboxControls = styled.div`
	display: flex;
	gap: 0.75rem;
`

export const LightboxButton = styled.button`
	background: rgba(255, 255, 255, 0.15);
	color: white;
	border: none;
	padding: 0.5rem 1rem;
	border-radius: 6px;
	font-size: 0.8rem;
	font-weight: 500;
	cursor: pointer;
	transition: background 0.2s;

	&:hover {
		background: rgba(255, 255, 255, 0.25);
	}
`

export const LightboxClose = styled.button`
	position: absolute;
	top: -2.5rem;
	right: -1rem;
	background: transparent;
	border: none;
	color: white;
	font-size: 2rem;
	cursor: pointer;
	line-height: 1;

	&:hover {
		opacity: 0.7;
	}
`
